import { render, staticRenderFns } from "./UserProfileMenu.vue?vue&type=template&id=792dce00"
import script from "./UserProfileMenu.vue?vue&type=script&lang=ts"
export * from "./UserProfileMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports